export default __webpack_public_path__ + "static/media/mystery.36bfc82e.png";